enum actionTypes {
  ADD_TO_BASKET = 'ADD_TO_BASKET',
  REMOVE_FROM_BASKET = 'REMOVE_FROM_BASKET',
  ADD_QUANTITY_BASKET_ITEM = 'ADD_QUANTITY_BASKET_ITEM',
}

export default actionTypes;
